import React from "react";
import { Routes, Route, HashRouter ,BrowserRouter } from "react-router-dom";
import "./App.css";
import LoginEnterOtp from "./containers/Pages/Login/LoginEnterOtp/index";
import LoginMobileNumber from "./containers/Pages/Login/LoginMobileNumber";
import RouteConstants from "./constants/routesContent.json";
import IntentOrderDetail from "./containers/Pages/OrderDetails";
import ResetPasswordIntent from "./containers/Pages/ResetPassword";
import Login from "./containers/Pages/Login/Login";
import LoginCredentails from "./containers/Pages/Login/LoginCredientails";
import IntentHistory from "./containers/Pages/IntentHistory";
import Thankyou from "./containers/Pages/Thankyou";
import LinkExpireView from "./containers/Pages/LinkExpired";
import RouteProtection from "./containers/RouteProtection";
import GateInPage from "./containers/Pages/GateIn";
import GateOutPage from "./containers/Pages/GateOut";
import MobileEnterOtp from "./containers/Pages/MobileOtp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path={RouteConstants.LOGIN} element={<Login />} />
          <Route
            path={RouteConstants.LOGIN_REGESTEDMOBILENUMBER}
            element={<LoginMobileNumber />}
          />
          <Route
            path={RouteConstants.LOGIN_OTP_CREDENTIALS}
            element={<LoginCredentails />}
          />
          <Route
            path={RouteConstants.LOGIN_ENTER_OTP}
            element={<LoginEnterOtp />}
          />
          <Route element={<RouteProtection />}>
            <Route
              path={RouteConstants.ORDER_DETAILS}
              element={<IntentOrderDetail />}
            />

            <Route path={RouteConstants.INTENT_HISTORY}>
              <Route index element={<IntentHistory />} />
              <Route
                path={RouteConstants.INTENT_HISTORY_DETAILS}
                element={<IntentOrderDetail />}
              />
            </Route>


            <Route
              path={RouteConstants.RESET_PASSWORD}
              element={<ResetPasswordIntent />}
            />
          </Route>
          <Route
            path={RouteConstants.LINK_EXPIRED}
            element={<LinkExpireView />}
          />
          <Route path={RouteConstants.THANK_YOU} element={<Thankyou />} />
          <Route
            path={RouteConstants.MOBILE_OTP}
            element={<MobileEnterOtp />}
          />
          <Route path={RouteConstants.GATE_IN} element={<GateInPage />} />
          <Route path={RouteConstants.GATE_OUT} element={<GateOutPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
